import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'
import InventoryOverviewSection from './InventoryOverviewSection'

import useManageDrawer from '../../../../../hooks/formHooks/useManageDrawer'
import { useFetchLineItemsHandler } from '../../../../../forms/GAM/UploadGamAdCreative/useFetchLineItemsHandler'

import { clearLineItems } from '../../../../../modules/actions/lineItems'
import { lineItemsWasLoadedSelector } from '../../../../../modules/selectors/lineItems'

import { INVENTORY_BREAKDOWN_AND_REQUIRED_CREATIVES } from '../../../../../constants/forms'

const InventoryBreakdownAndRequiredCreatives = ({ rightCampaignsToLoadIds }) => {
  const dispatch = useDispatch()
  const lineItemsWasLoaded = useSelector(lineItemsWasLoadedSelector)

  const clearHandler = useCallback(() => {
    if (lineItemsWasLoaded) {
      dispatch(clearLineItems())
    }
  }, [dispatch, lineItemsWasLoaded])

  const { isFormOpen } = useManageDrawer({
    formName: INVENTORY_BREAKDOWN_AND_REQUIRED_CREATIVES,
    onAfterFormClose: clearHandler
  })

  const isFormLoading = useMemo(() => {
    if (rightCampaignsToLoadIds?.length) {
      return !lineItemsWasLoaded
    } else {
      return false
    }
  }, [lineItemsWasLoaded, rightCampaignsToLoadIds])

  const fetchLineItemsHandler = useFetchLineItemsHandler({
    rightCampaignsToLoadIds
  })

  useEffect(() => {
    if (isFormOpen && !lineItemsWasLoaded && rightCampaignsToLoadIds?.length) {
      fetchLineItemsHandler()
    }
  }, [isFormOpen, rightCampaignsToLoadIds, dispatch, lineItemsWasLoaded, fetchLineItemsHandler])

  useEffect(
    () => () => {
      dispatch(clearLineItems())
    },
    [dispatch]
  )

  return (
    <FormDrawerWrapper
      formName={INVENTORY_BREAKDOWN_AND_REQUIRED_CREATIVES}
      title="Inventory breakdown & required creatives"
      openButtonText={'Inventory details & required creatives'}
      isFormLoading={isFormLoading}
    >
      <InventoryOverviewSection />
    </FormDrawerWrapper>
  )
}

InventoryBreakdownAndRequiredCreatives.propTypes = {
  rightCampaignsToLoadIds: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default InventoryBreakdownAndRequiredCreatives
